import { render, staticRenderFns } from "./centurion-jewellery.vue?vue&type=template&id=4521866c&scoped=true&"
import script from "./centurion-jewellery.vue?vue&type=script&lang=js&"
export * from "./centurion-jewellery.vue?vue&type=script&lang=js&"
import style0 from "./centurion-jewellery.vue?vue&type=style&index=0&id=4521866c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4521866c",
  null
  
)

export default component.exports